import { render } from "./TheSidebar.vue?vue&type=template&id=6cee0282&scoped=true&ts=true"
import script from "./TheSidebar.vue?vue&type=script&lang=ts"
export * from "./TheSidebar.vue?vue&type=script&lang=ts"

import "./TheSidebar.vue?vue&type=style&index=0&id=6cee0282&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cee0282"]])

export default __exports__